import type { DashboardChart } from './types';

export type ChartView = DashboardChart['kind'] | 'area' | 'columns';
export const chartViews = (chart: DashboardChart): { value: ChartView; label: string }[] => {
  if (chart.kind === 'line')
    return [
      { value: 'line', label: 'Courbes' },
      { value: 'area', label: 'Aires' },
      { value: 'columns', label: 'Colonnes' },
    ];
  // Monetary averages are not additive: a donut would imply a misleading share of a total.
  if (chart.unit === 'number' && (chart.kind === 'donut' || chart.kind === 'bars'))
    return [
      { value: 'donut', label: 'Anneau' },
      { value: 'bars', label: 'Barres' },
    ];
  return [];
};
